import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ISystemRolesApiClient } from './i-system-roles-api.client';
import { systemRolesData } from '../data';
import { ILookup, IPaginationParameters, IPaginationResponse } from '../../../../core';

@Injectable({
  providedIn: 'root'
})
export class SystemRolesApiInMemoryClient implements ISystemRolesApiClient {

  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<ILookup<string>>> {
    return of(systemRolesData.systemRolesResponse);
  }
}